<template>
	<div class="owl-carousel slider-navigation">
		<div class="item" v-for="item in items">
			<div class="wr">
				<!-- <pre>{{item}}</pre> -->
				<div class="topBlock">
					<a :href="item.buttonHref" class="imgContainer" :style='`background-image: url(${item.img})`'></a>
					<div class="labelContainer">
						<div v-if="item.newLabel" class="newLabel">{{item.newLabel}}</div>
						<div v-if="item.recomendedLabel" class="recomendedLabel">{{item.recomendedLabel}}</div>
					</div>
					<a :href="item.href" v-if="item.moreColorsImg" class="moreColors">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
								<path d="M24 0H0v24h24z" fill="none"/>
								<path d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"/>
						</svg>
						<span v-html="item.moreColorsImg"></span>
					</a>
				</div>
				<div class="middleBlock"></div>
				<div class="bottomBlock">
					<div class="infoContainer">
						<div class="stars">
							<div
								v-if="item.stars ? item.stars : 1"
								v-for="(star, n) in 5"
								:class="n < item.stars ? 'star full' : 'star empty'" >
								<svg viewBox="0 0 18 18"  xmlns="http://www.w3.org/2000/svg">
								    <path d="M9 11.3l3.71 2.7-1.42-4.36L15 7h-4.55L9 2.5 7.55 7H3l3.71 2.64L5.29 14z"/>
								    <path d="M0 0h18v18H0z" fill="none"/>
								</svg>
							</div>
						</div>
						<div v-if="item.inStock" class="inStock">{{item.inStock}}</div>
					</div>
					<a v-if="item.title" :href="item.href" class="title">{{item.title}}</a>

					<p v-if="item.delivery" class="delivery">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
							<path d="M22 11.07V12a10 10 0 1 1-5.93-9.14"></path>
							<polyline points="23 3 12 14 9 11"></polyline>
						</svg>
						<span class="deliveryText">{{item.delivery}}</span>
					</p>
					<a :href="item.href" v-if="item.moreColorsBottom" class="moreColors">
						<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
								<path d="M24 0H0v24h24z" fill="none"/>
								<path d="M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"/>
						</svg>
						<span v-html="item.moreColorsBottom"></span>
					</a>

					<div class="priceAndBuy">
						<div class="priceContainer">
								<p v-if="item.oldPrice" class="oldPrice" v-html="item.oldPrice"></p>
								<p v-if="item.price" class="price" v-html="item.price"></p>
						</div>
						<a class="yam-button waves-effect waves-light" v-if="item.buttonText" :href="item.buttonHref">{{item.buttonText}}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 2 ? true : false,
				nav: true,
				dots: true,
				margin: 30,
				responsive: {
					0: {
						items: 1,
					},
					768: {
						items: 2,
					}
				}
			}
		});
	}
}
</script>
<style lang="scss" scope=".slider-stockProduct">
	@import "scss/wanted";
	.slider-stockProduct {
		position: relative;
		padding-bottom: 63px;
		margin-bottom: 69px;
	  .owl-carousel {
			.item {
				height: 445px;
				padding: 0px 0px;
				background-color: transparent;
				// margin-bottom: -7px;
				width: 100%;
				.wr{
					position: relative;
					background-color: transparent;

					&:after{
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						left: 0;
						z-index: -1;
						content: '';
						border-radius: 5px;
						box-shadow: 0px 3px 5.88px 0.12px rgba(226, 237, 243, 0.5);
					}
				}
				.topBlock{
					height: 225px;
					background-position: center;
					background-repeat: no-repeat;
					border: 1px solid #e2edf3;
					border-radius: 5px;
					border-bottom: none;
					border-bottom-right-radius: 0;
					border-bottom-left-radius: 0;
					background-color: white;
					position: relative;
					background-size: auto 140px;
					background-position: center;
					.imgContainer{
						display: block;
						width: 100%;
						height: 100%;
						background-position: center;
						background-repeat: no-repeat;
						background-size: auto 140px;
					}
					.labelContainer{
						position: absolute;
						top: 14px;
						left: 14px;
						div{
							display: inline-block;
							font-size: rem(11);
							height: 20px;
							line-height: rem(21);
							color: #fff;
							border-radius: 10px;
							padding: 0 10px;
							margin-right: 6px;
						}
						.newLabel{
							background-color: #48a45d;
						}
						.recomendedLabel{
							background-color: #1973fb;
						}
						.saleLabel{
							background: #de4b39;
						}
					}
					.colors{
						position: absolute;
						left: 20px;
						bottom: 14px;
						height: auto;
						width: 20px;
						.dot{
							border-radius: 50%;
							box-shadow: 0px 3px 4px rgba(#000,0.2);
							width: 18px;
							height: 18px;
							margin-bottom: 10px;
							position: relative;
							cursor: pointer;
							background-color: white;
							display: flex;
							justify-content: center;
							align-items: center;
							span{
								position: relative;
								left: 0;
								right: 0;
								top: 0;
								bottom: 0;
								margin: 0 auto;
								border-radius: 50%;
								width: 14px;
								height: 14px;
								display: inline-block;
							}
						}
					}
					.moreColors{
						position: absolute;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
						justify-content: center;
						font-size: rem(13);
						line-height: rem(24);
						color: #7e8183;
						display: flex;
						margin-bottom: 5px;
						height: rem(24);
						align-items: center;
						overflow: hidden;
						b{
							font-weight: normal;
							font-weight: 900;
						}
						span{
							text-decoration: underline;
							text-decoration-color: #dfdfe0;
						}
						svg{
							width: 18px;
							height: 18px;
							margin-right: 5px;
							fill: var(--bg-color);
							&:hover{
								fill:var(--bg-hover);
							}
						}
					}
				}
				.middleBlock{
					position: relative;
					height: 8px;
					background-image: url('../img/bgDot.png');
					background-position: center;
					background-repeat: repeat-x;
					margin: 0 6px;
					background-color: white;
					&:before{
						position: absolute;
						left: -7px;
						top: -1px;
						width: 6px;
						height: 10px;
						content: "";
						background-image: url('../img/bgArr.png');
					}
					&:after{
						position: absolute;
						right: -7px;
						top: -1px;
						width: 6px;
						height: 10px;
						content: "";
						background-image: url('../img/bgArr.png');
						transform: rotate(180deg);
					}
				}
				.bottomBlock{
					padding: rem(25) rem(29);
					height: 205px;
					border: 1px solid #e2edf3;
					border-radius: 5px;
					border-top: none;
					border-top-right-radius: 0;
					border-top-left-radius: 0;
					background-color: white;
					.infoContainer{
						display: flex;
						justify-content: space-between;
						margin-bottom: 2px;
						height: rem(24);
						.stars{
							display: flex;
							justify-content: flex-start;
							div{
								display: flex;
								justify-content: flex-start;
								svg{
									width: 18px;
									height: 18px;
									fill: #bebfc1;
									&.full{
										fill: #fe8f00;
									}
								}
								&.full{
									svg{
										fill: #fe8f00;
									}
								}
								&.yempty {
									svg{
										fill: #bec0c1;
									}
								}
							}
						}
						.inStock{
							font-size: rem(12);
							line-height: rem(24);
							color: #48a45d;
							padding-left: 20px;
							position: relative;
							margin-left: auto;
							&:before{
								position: absolute;
								left: 0;
								top: calc(50% - 8px);
								width: 14px;
								height: 14px;
								content: "";
								background-image: url('../img/smile.svg');
								background-size: cover;
							}
							&.yempty {
								color: #989b9d;
								&:before{
									background-image: url('../img/smile_empty.svg');
								}
							}
							&.little{
								color: #933EC5;
								&:before{
									background-image: url('../img/smile_little.svg');
								}
							}
						}
					}
					.title{
						font-size: rem(14);
						line-height: rem(22);
						height: rem(44);
						overflow: hidden;
						color: black;
						text-decoration: none;
						margin-bottom: 4px;
						padding: 0;
						font-weight: 900;
						display: block;
						&:hover{
							text-decoration: underline;
						}
					}
					.delivery{
						font-size: rem(12);
						line-height: rem(24);
						color: #7e8183;
						display: flex;
						margin-bottom: 7px;
						height: rem(24);
						align-items: center;
						overflow: hidden;
						svg{
							width: 14px;
							height: 14px;
							stroke: #48a45d;
							margin-right: 8px;
						}
						.deliveryText{
							white-space: nowrap;
							text-overflow: ellipsis;
							overflow: hidden;
						}
					}
					.moreColors{
						font-size: rem(13);
						line-height: rem(24);
						color: #7e8183;
						display: flex;
						margin-bottom: 7px;
						height: rem(24);
						align-items: center;
						overflow: hidden;
						b{
							font-weight: 900;
						}
						span{
							text-decoration: underline;
							text-decoration-color: #dfdfe0;
						}
						svg{
							width: 18px;
							height: 18px;
							margin-right: 5px;
							fill: var(--bg-color);
							&:hover{
								fill:var(--bg-hover);
							}
						}
					}
					.priceAndBuy{
						display: flex;
						justify-content: space-between;
						.priceContainer{
							.oldPrice{
								font-size: rem(13);
								line-height: rem(20);
								height: rem(20);
								color: #7e8183;
								b{
									text-decoration: line-through;
								}
								i{
									font-style: normal;
									font-size: rem(11);
								}
							}
							.sale{
								font-size: rem(13);
								font-family: $ProximaNova_regular;
								height: rem(20);
								b{
									font-weight: normal;
									/* color: #de4b39; */
								}
								i{
									font-style: normal;
									font-size: rem(11);
									/* color: #de4b39; */
								}
							}
							.price{
								font-size: rem(20);
								line-height: rem(20);
								height: rem(20);
								color: #000;
								font-weight: 900;
								@include l_up{
									font-size: rem(18);
									margin-top: -4px;
								}
								@include l__up{
									font-size: rem(20);
									margin-top: 0px;
								}
								i{
									font-style: normal;
									font-size: rem(14);
								}
							}
						}
						.yam-button{
							width: 120px;
							height: 43px;
							font-size: rem(16);
							line-height: 43px;
							margin: auto;
							margin-right: 0;
							@include l_up{
								font-size: rem(16);
								width: 110px;
							}
							@include l__up{
								font-size: rem(16);
								width: 120px;
							}
						}
					}
				}
			}
			.owl-dots{
				justify-content: flex-strat;
				padding-bottom: 3px;
				bottom: -55px;
			}
			.owl-nav{
				font-size: 0;
				display: flex;
				justify-content:space-between;
				width: 100px;
				position: absolute;
				right: 0;
				bottom: -90px;
				z-index: 11;
			}
	  }
	}
</style>



// WEBPACK FOOTER //
// stock-product.vue?9b80cb30